export const materials: string[] = [
    "p1",
    "p2",
    "p3",
    "p4",
    "m1",
    "m2",
    "k1",
    "k2",
    "n1",
    "n2",
    "n3",
    "s1",
    "s2",
    "h1",
    "h2",
    "h3",
    "c_cfk",
    "c_gfk",
    "c_afk",
    "c_elast",
]

export const cuttingsSpeeds = ["00", "01", "02"]